import React from "react";

const TipoTextoPregunta = ({ pregunta, onResponder, className = "" }) => {
  return (
    <>
      {pregunta.textoPregunta && (
        <div className="texto-pregunta-card">
          <p
            style={{
              fontSize: `${pregunta.textoPregunta.tamañoText}px`,
              lineHeight: `${pregunta.textoPregunta.lineHeight}rem`,
              width: `${pregunta.textoPregunta.width}%`,
            }}
            className="container-text-pregunta"
          >
            {pregunta.textoPregunta.text}
          </p>
        </div>
      )}

      <p
        className={`pregunta-texto ${className}`}
        style={{
          marginBottom: "40px",
        }}
      >
        {pregunta.pregunta || "¿Cómo percibes el texto anterior?"}
      </p>

      <div className="botones-ojo">
        {pregunta.opciones.map((opcion, index) => (
          <button
            key={index}
            className="btn-ojo"
            onClick={() => onResponder(index)}
          >
            {opcion.text}
          </button>
        ))}
      </div>
    </>
  );
};

export default TipoTextoPregunta;